/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Response/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Response({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Answer/Response",
  isSkipped,
  isDisabled,
  isHovered
  
}) {
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let answerAnswerValueValueData = fromData.useDataValue({ viewPath,
context: 'answer',
path: 'answerValue',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let aggregateData = fromHelpers.populateTemplate(widgetQuestionsValueData, answerAnswerValueValueData, selectedAnswersValueData)
let answerTextTransformValueData = fromData.useDataFormat({ viewPath,
context: 'answer',
path: 'textTransform',
format: fromHelpers.hasTextTransform,
})
let dtResponseColorBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Response.color.brand.base'
        })
let dtResponseColorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Response.color.brand.hovered'
        })
let dtResponseColorBrandDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Response.color.brand.disabled'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={isHovered ? dtResponseColorBrandHovered : dtResponseColorBrandBase}
 fontSize={16}
 fontWeight={300}
 lineHeight={1.3}
 data="widget.questions"
 data="answer.answerValue"
 data="selected.answers"
 aggregate="helpers.js populateTemplate"
 text={aggregateData}
 data="answer.textTransform"
 format="helpers.js hasTextTransform"
 textTransform={answerTextTransformValueData}
/>
{children}
</React.Fragment>)
}